export function isLowerCaseEqual(val1: string, val2: string): boolean {
  return val1.toLowerCase() === val2.toLowerCase();
}
